import React from 'react';
import {Form} from "formik";
import {FilledInput, FormControl, Grid, InputLabel, Typography} from "@mui/material";
import PrimaryButton from "../../Common/PrimaryButton";

const AccessCodeForm = ({values, handleChange}) => {
    return (
        <Form>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Typography variant="h5">Guest Access Code</Typography>
                    <FormControl variant="filled" fullWidth>
                        <InputLabel htmlFor="accessToken">Access Code</InputLabel>
                        <FilledInput id="accessToken" name="accessToken"
                                     value={values.accessToken}
                                     onChange={handleChange} disableUnderline/>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <PrimaryButton type="submit" style={{margin: 0}}>
                        Submit
                    </PrimaryButton>
                </Grid>
            </Grid>
        </Form>
    );
};

export default AccessCodeForm;